import React, { useState, useEffect } from "react";

function ExpensesStep({ onNext, onBack, expenses = [] }) {
  const defaultCategories = [
    "Childcare",
    "Clothing & Personal Care",
    "Public / Government School Fees",
    "Groceries",
    "General Insurance",
    "Personal Insurance",
    "Investment Property Costs",
    "Primary Residence Costs",
    "Strata / Body Corporate / Land Tax",
    "Recreation & Entertainment",
    "Board",
    "Rent",
    "Telephone / Internet / Pay TV / Streaming",
    "Transport",
    "Other Regular & Recurring Expenses",
  ];

  const [items, setItems] = useState([]);

  useEffect(() => {
    if (expenses && expenses.length > 0) {
      setItems(expenses);
    } else {
      // preload all categories with empty monthly values
      setItems(
        defaultCategories.map((c) => ({
          category: c,
          owner: "Applicant 1",
          amount: "",
        }))
      );
    }
  }, [expenses]);

  const updateItem = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = value;
    setItems(updated);
  };

  const totalExpenses = items.reduce((sum, i) => {
    return sum + (parseFloat(i.amount) || 0);
  }, 0);

  const handleContinue = () => {
    onNext({ expenses: items });
  };

  return (
    <div>
      <h2>Monthly Living Expenses</h2>

      <div style={{ marginBottom: "1rem" }}>
        <strong>Total Monthly Expenses:</strong> ${totalExpenses.toLocaleString()}
      </div>

      {items.map((item, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            gap: "10px",
            marginBottom: "8px",
            alignItems: "center",
          }}
        >
          {/* Category */}
          <div style={{ width: "300px" }}>{item.category}</div>

          {/* Owner */}
          <select
            value={item.owner}
            onChange={(e) => updateItem(index, "owner", e.target.value)}
          >
            <option value="Applicant 1">Applicant 1</option>
            <option value="Applicant 2">Applicant 2</option>
            <option value="Shared">Shared</option>
          </select>

          {/* Fixed Frequency: Monthly */}
          <div>Monthly</div>

          {/* Amount */}
          <input
            type="number"
            placeholder="$"
            value={item.amount}
            onChange={(e) => updateItem(index, "amount", e.target.value)}
            style={{ width: "120px" }}
          />
        </div>
      ))}

      <br />
      <button onClick={onBack}>⬅️ Back</button>
      <button onClick={handleContinue} style={{ marginLeft: "10px" }}>
        Continue ➡️
      </button>
    </div>
  );
}

export default ExpensesStep;
